define('views/content/reseller_license',['require','backbone','marionette','typeahead','bloodhound','text!templates/content/reseller_license.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('typeahead');
    require('bloodhound');


    var temp = require("text!templates/content/reseller_license.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'reseller-license-page',
        titleKey: 'license',
        selectedCustomer: null,

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                customerField: '#customer',
                countField: '#count',
                assignButton: '#assign-button'
            };
        },

        events: {
            'click @ui.assignButton': 'assignButtonClicked'
        },
        
        onRender: function() {
            var _this = this;

            // Setup typeahed for customer field
            var customerssTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'customers/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.customerField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.customerField.typeahead({
                minLength: 3
            }, {
                name: 'resellers',
                source: customerssTypeahedEngine,
                display: 'company_name'
            });

            // Get selected customer's id
            this.ui.customerField.bind('typeahead:select', function (ev, suggestion) {
                _this.selectedCustomer = suggestion.id;
            });
        },

        assignButtonClicked: function () {
            var _this = this;

            if (this.selectedCustomer) {
                _this.ui.assignButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'reseller-products/' + this.model.get('id') + '/assign_license/',
                    method: 'post',
                    data: {
                        customer: this.selectedCustomer,
                        count: this.ui.countField.val()
                    },
                    success:function(response) {
                        _this.ui.assignButton.removeClass('loading');

                        _this.model.set(response);
                        _this.render();

                        App.utils.showMessage('success', App.polyglot.t('assign_success'));
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.assignButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            }
        }

    });
});
